﻿import { defineWidgets, parse, parser, registry } from "blue-widgets";
import * as widgets from "./widgets";


defineWidgets({
    ...widgets,
});

parse();

